/**
 * @desc 库存变动记录表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.inoutStepRecord.exportInoutStepRecord.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inoutStepRecord/exportInoutStepRecord`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
